module.exports = __webpack_public_path__ + "static/media/picture1@2x.5fd1862f.png";